import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { WorkspaceRedFlagListScreen } from '@/features/red-flags/components/workspace/RedFlagListScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  status: z.enum(['open', 'under_review', 'closed']).optional(),
});

export const Route = createFileRoute('/_staff/admin/workspace/red-flags/')({
  validateSearch: (input) => searchSchema.parse(input),
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  component: WorkspaceRedFlagListScreen,
  staticData: { crumb: 'Red flags' },
});
